import React from 'react';
import {Button} from '@forecast-it/design-system';
import {useAgentDrawerContext} from '../../forecast-app/shared/contexts/AgentDrawerContext';
import {useIntl} from 'react-intl';

const AgentTriggerButton = (): JSX.Element => {
	const {isOpen, openDrawer, closeDrawer} = useAgentDrawerContext();
	const {formatMessage} = useIntl();

	const label = isOpen ? formatMessage({id: 'nova.trigger.close_label'}) : formatMessage({id: 'nova.trigger.open_label'});

	return (
		<Button
			emphasis="medium"
			rightIcon="sparkle"
			onPress={isOpen ? closeDrawer : openDrawer}
			aria-label={label}
			data-cy="agent-trigger-button"
		>
			{formatMessage({id: 'nova.trigger.ask_ai'})}
		</Button>
	);
};

export default AgentTriggerButton;
